<!--
Author: TangChen
Date: 2018-11-22
Desc: 修改用户信息组件
 -->
<template>
    <div class="comp-user-info comp">
        <el-row class="acct-box">
            <el-form
                ref="acctInfo"
                :model="acctInfo"
                :rules="rules"
                :label-width="(fn?'160':'160')+'px'"
                class="acct-form"
                :class="{'certexpdate-box':fn}"
                :disabled="acctInfo.usertype==='2'"
                v-on:submit.native.prevent
            >
                <el-col :span="24">
                    <el-form-item label="姓名：" class="form-text">
                        <div class="text-con">
                            {{ acctInfo.custname }}
                        </div>
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn" :span="12">
                    <el-form-item label="证件类型：">
                        <div v-if="!$util.isEmpty(acctInfo.certificatetype)" class="text-con">
                            {{ $cache.getDict('130007',acctInfo.certificatetype) }}
                        </div>
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn" :span="12">
                    <el-form-item label="证件号码：">
                        <div class="text-con">
                            {{ acctInfo.certificateno }}&emsp;
                            <el-button v-if="ocrOnOff" :disabled="ocrStatus" type="warning" size="mini" v-on:click="gotoUpdOcr">
                                {{ ocrBtnInfo }}
                            </el-button>
                        </div>
                    </el-form-item>
                </el-col>
                <el-col v-if="fn" :span="24">
                    <el-form-item :label="$cache.getDict('130007',acctInfo.certificatetype)+'：'">
                        <div class="text-con">
                            {{ acctInfo.certificateno }}
                        </div>
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn||(fn && !isBirthdate)" :span="12">
                    <el-form-item label="出生日期：" prop="birthdate" :class="{'required':!acctInfo.birthdate}">
                        <date-picker v-if="!isBirthdate" :date="birthSet" v-on:date-get="dateBirth" />
                        <div v-if="isBirthdate" class="text-con">
                            {{ $util.fmtDate(acctInfo.birthdate) }}
                        </div>
                    </el-form-item>
                </el-col>
                <el-col v-if="!isMobile && !fn" :span="12">
                    <el-form-item label="手机号码：" prop="mobile">
                        <div class="text-con">
                            {{ acctInfo.mobile.length === 11?acctInfo.mobile:'没有绑定手机号' }}
                            <el-button type="warning" size="mini" v-on:click.prevent="$router.push({name:$util.isEmpty(acctInfo.mobile)?'bindmobile':'checkmobile'})">
                                {{ (!$util.isEmpty(acctInfo.mobile)?'修改':'绑定') }}
                            </el-button>
                        </div>
                    </el-form-item>
                </el-col>
                <el-col v-else-if="!fn" :span="12">
                    <el-form-item label="手机号码：" class="required">
                        <div class="text-con">
                            {{ acctInfo.mobile }}
                        </div>
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn || (fn && !$cache.getUser().country.trim())" :span="12">
                    <el-form-item label="国籍：" prop="country" class="required">
                        <el-select v-model.trim="acctInfo.country" filterable placeholder="请选择国籍">
                            <el-option
                                v-for="item in country"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col v-if="(!fn && acctInfo.country=='CN') || (fn && acctInfo.country=='CN' && !$cache.getUser().province.trim())" :span="12">
                    <el-form-item label="省份：" prop="province" class="required">
                        <el-select v-model.trim="acctInfo.province" filterable placeholder="请选择省份">
                            <el-option
                                v-for="item in province"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn || (fn && !isCertexpdate)" :span="12">
                    <el-form-item label="证件有效期：" prop="vailddate" class="required">
                        <date-picker :date="dateSet" v-on:date-get="dateInterval" />
                    </el-form-item>
                </el-col>
                <!--现居地址-->
                <el-col v-if="!fn || (fn && (!$cache.getUser().livingcountry.trim() || !$cache.getUser().livingaddress.trim()))" :span="24">
                    <country-city-select ref="livingaddress" v-model="livingAddressObj" required country-layout="user" v-on:input="getAdrss"></country-city-select>
                </el-col>
                <el-col v-if="!fn || (fn && (!$cache.getUser().livingcountry.trim() || !$cache.getUser().livingaddress.trim()))" :span="24">
                    <el-form-item label="通讯（现居）地址：" prop="address" class="required">
                        <el-input
                            v-model.trim="acctInfo.address"
                            placeholder="请输入（现居）通讯地址（例如：xx市xx省xx区xx街道xx号）"
                            :maxlength="32"
                            :style="fn?'':'width: 87%;'"
                        />
                    </el-form-item>
                </el-col>
                <!--<el-col v-if="!fn || (fn && !$cache.getUser().annualincome.trim())" :span="12">-->
                <!--<el-form-item label="年收入（元）：" prop="annualincome">-->
                <!--<el-input-->
                <!--v-model.trim="acctInfo.annualincome"-->
                <!--placeholder="请输入年收入金额   "-->
                <!--:maxlength="20"-->
                <!--/>-->
                <!--</el-form-item>-->
                <!--</el-col>-->
                <el-col v-if="!fn || (fn && !$cache.getUser().annualincome.trim())" :span="12">
                    <el-form-item label="年收入（元）：" prop="annualincome" class="required">
                        <el-input
                            v-model.trim="acctInfo.annualincome"
                            placeholder="请输入年收入"
                        />
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn || (fn && !$cache.getUser().specialpersonflag.trim())" :span="12">
                    <el-form-item label="特定自然人标识：" prop="specialpersonflag" class="required">
                        <el-select v-model.trim="acctInfo.specialpersonflag" filterable placeholder="请选择特定自然人标识">
                            <el-option
                                v-for="item in specialpersonflag"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <!--<el-col v-if="!fn || (fn && !$cache.getUser().isdigniaryorceo.trim())" :span="12">-->
                <!--<el-form-item label="受益人类型：" prop="isdigniaryorceo" class="required">-->
                <!--<el-select v-model.trim="acctInfo.isdigniaryorceo" filterable placeholder="请选择受益人类型">-->
                <!--<el-option-->
                <!--v-for="item in isdigniaryorceo"-->
                <!--:key="item.subitem"-->
                <!--:label="item.subitemname"-->
                <!--:value="item.subitem"-->
                <!--/>-->
                <!--</el-select>-->
                <!--</el-form-item>-->
                <!--</el-col>-->
                <el-col v-if="acctInfo.specialpersonflag!=='0' && acctInfo.specialpersonflag!=='A'" :span="12">
                    <el-form-item label="财产和资金来源：" prop="assetssource" :class="(acctInfo.specialpersonflag!=='0' && acctInfo.specialpersonflag!=='A')?'required':''">
                        <el-input v-model.trim="acctInfo.assetssource" placeholder="请输入财产和资金来源" :maxlength="64" />
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn || (fn && !$cache.getUser().occupation.trim())" :span="12">
                    <el-form-item label="职业：" prop="occupation" class="required">
                        <el-select v-model.trim="acctInfo.occupation" filterable placeholder="请选择职业">
                            <el-option
                                v-for="item in vocationcode"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn && acctInfo.occupation==='06'" :span="12">
                    <el-form-item label="职业补充信息：" prop="vocationsupple" :class="{'required':acctInfo.occupation==='06'}">
                        <el-input v-model.trim="acctInfo.vocationsupple" placeholder="请输入职业补充信息" :maxlength="22" />
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn || (fn && !$cache.getUser().educationlevel.trim() )" :span="12">
                    <el-form-item label="学历：" prop="educationlevel" class="required">
                        <el-select v-model="acctInfo.educationlevel" filterable placeholder="请选择学历">
                            <el-option
                                v-for="item in educationlevel"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn ||(fn && !isDelivertype)" :span="12">
                    <el-form-item label="对账单寄送周期：" prop="delivertype" class="required">
                        <el-select v-model.trim="acctInfo.delivertype" filterable placeholder="请选择对账单寄送周期">
                            <el-option
                                v-for="item in delivertype"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn || (fn && !isDelivertype)" :span="12">
                    <el-form-item
                        v-if="acctInfo.delivertype && acctInfo.delivertype!=='1'"
                        label="对账单寄送方式："
                        prop="deliverway"
                        class="required"
                    >
                        <el-radio-group v-model.trim="acctInfo.deliverway">
                            <el-radio v-for="item in deliverway" :key="item.subitem" :label="item.subitem">
                                {{ item.subitemname }}
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item class="radio-list required" label="性别：" prop="sex">
                        <el-radio-group v-model.trim="acctInfo.sex">
                            <el-radio v-for="item in sex" :key="item.subitem" :label="item.subitem">
                                {{ item.subitemname }}
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn || (fn && !isDelivertype && acctInfo.deliverway==='1')" :span="12">
                    <el-form-item label="邮政编码：" prop="postcode" :class="{'required':acctInfo.deliverway==='1'}">
                        <el-input v-model.trim="acctInfo.postcode" placeholder="请输入邮政编码" :maxlength="6" />
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn || (fn && !isDelivertype && acctInfo.deliverway==='3')" :span="12">
                    <el-form-item label="电子邮箱：" prop="email" :class="{'required':acctInfo.deliverway==='3'}">
                        <el-input v-model.trim="acctInfo.email" placeholder="请输入电子邮箱" :maxlength="32" />
                    </el-form-item>
                </el-col>
                <el-col v-if="fn || $cache.getUser().hometelno.trim()" :span="24">
                    <el-form-item label="住址电话：" prop="hometelno" :class="acctInfo.hometelno ? 'required' : ''">
                        <el-select
                            v-model="acctInfo.hometelnocycode"
                            placeholder="请选择国家码"
                            style="width:150px!important"
                        >
                            <el-option
                                v-for="item in telnocycode"
                                :key="item.subitem"
                                :label="item.subitemname+' '+item.subitem"
                                :value="item.subitem"
                            />
                        </el-select>
                        <el-select
                            v-if="acctInfo.hometelnocycode == '86'"
                            v-model="acctInfo.hometelnoareacode"
                            placeholder="请选择地区码"
                            style="width:150px!important"
                        >
                            <el-option
                                v-for="item in telnoareacode"
                                :key="item.subitem"
                                :label="item.subitemname+' '+item.subitem"
                                :value="item.subitem"
                            />
                        </el-select>
                        <el-input v-else v-model.trim="acctInfo.hometelnoareacodeinput" placeholder="请输入地区码" style="width:150px!important" />
                        <el-input v-model.trim="acctInfo.hometelno" placeholder="请输入住址电话号码" :maxlength="11" style="width:300px" />
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn || (
                    fn &&
                (!$cache.getUser().telno.trim() || !$cache.getUser().telnocycode.trim() ||!$cache.getUser().telnoareacode.trim())
                )" :span="24">
                    <el-form-item label="电话号码：" prop="telno" :class="acctInfo.telno ? 'required' : ''">
                        <el-select
                            v-model="acctInfo.telnocycode"
                            placeholder="请选择国家码"
                            style="width:150px!important"
                        >
                            <el-option
                                v-for="item in telnocycode"
                                :key="item.subitem"
                                :label="item.subitemname+' '+item.subitem"
                                :value="item.subitem"
                            />
                        </el-select>
                        <el-select
                            v-if="acctInfo.telnocycode == '86'"
                            v-model="acctInfo.telnoareacode"
                            placeholder="请选择地区码"
                            style="width:150px!important"
                        >
                            <el-option
                                v-for="item in telnoareacode"
                                :key="item.subitem"
                                :label="item.subitemname+' '+item.subitem"
                                :value="item.subitem"
                            />
                        </el-select>
                        <el-input v-else v-model.trim="acctInfo.telnoareacodeinput" placeholder="请输入地区码" style="width:150px!important" />
                        <el-input v-model.trim="acctInfo.telno" placeholder="请输入电话号码" :maxlength="11" style="width:300px" />
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn || (fn && (!$cache.getUser().fax.trim()||!$cache.getUser().faxcycode.trim()||!$cache.getUser().faxareacode.trim()))" :span="24">
                    <el-form-item label="传真号码：" prop="fax" :class="{'required':acctInfo.deliverway==='2'}">
                        <el-select
                            v-model="acctInfo.faxcycode"
                            placeholder="请选择国家码"
                            style="width:150px!important"
                        >
                            <el-option

                                v-for="item in telnocycode"
                                :key="item.subitem"
                                :label="item.subitemname+' '+item.subitem"
                                :value="item.subitem"
                            />
                        </el-select>
                        <el-select
                            v-if="acctInfo.faxcycode == '86'"
                            v-model="acctInfo.faxareacode"
                            placeholder="请选择地区码"
                            style="width:150px!important"
                        >
                            <el-option
                                v-for="item in telnoareacode"
                                :key="item.subitem"
                                :label="item.subitemname+' '+item.subitem"
                                :value="item.subitem"
                            />
                        </el-select>
                        <el-input v-else v-model.trim="acctInfo.faxareacodeinput" placeholder="请输入地区码" style="width:150px!important" />
                        <el-input v-model.trim="acctInfo.fax" placeholder="请输入传真号码" :maxlength="8" style="width:300px;" />
                    </el-form-item>
                </el-col>

                <!--受益人信息-->
                <el-col style="margin-bottom:20px">
                    <div class="border"></div>
                </el-col>
                <el-col>
                    <span class="amount">实际受益人</span>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="受益人类型：" prop="benefisself" class="required">
                        <el-select v-model.trim="acctInfo.benefisself" placeholder="请选择受益人类型">
                            <el-option
                                v-for="item in benefisself"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <!--<el-col v-if="!fn && acctInfo.benefisself==='0'" :span="12">-->
                <!--<el-form-item label="收入来源：" prop="assetssource" :class="(acctInfo.benefisself==='1')?'required':''">-->
                <!--<el-input v-model.trim="acctInfo.assetssource" placeholder="请输入收入来源" :maxlength="20" />-->
                <!--</el-form-item>-->
                <!--</el-col>-->
                <el-col v-if="acctInfo.benefisself==='0'" :span="12">
                    <el-form-item label="账户实际受益人：" prop="beneficiary" class="required">
                        <el-input v-model.trim="acctInfo.beneficiary" placeholder="请输入受益人姓名" :maxlength="20" />
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.benefisself==='0'" :span="12">
                    <el-form-item label="受益人证件类型：" prop="beneficiarytype" class="required">
                        <el-select v-model.trim="acctInfo.beneficiarytype" placeholder="请选择受益人证件类型">
                            <el-option
                                v-for="item in beneficiarytype"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.benefisself==='0'" :span="12">
                    <el-form-item label="受益人证件号码：" prop="beneficiaryno" class="required">
                        <el-input v-model.trim="acctInfo.beneficiaryno" placeholder="请输入受益人证件号码" :maxlength="32" />
                    </el-form-item>
                </el-col>
                <el-col v-if="(!fn && acctInfo.benefisself==='0') || (fn && !isBeneficiarydateflag)" :span="12">
                    <el-form-item label="受益人证件有效期：" prop="beneficiarydate" class="required">
                        <date-picker :date="beneficiaryDateSet" v-on:date-get="beneficiaryDateInterval" />
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.benefisself==='0'" :span="12">
                    <el-form-item class="radio-list" label="性别：" prop="beneficiarysex">
                        <el-radio-group v-model.trim="acctInfo.beneficiarysex">
                            <el-radio v-for="item in beneficiarysex" :key="item.subitem" :label="item.subitem">
                                {{ item.subitemname }}
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.benefisself==='0'" :span="12">
                    <el-form-item label="受益人出生日期：" prop="beneficiarybirthday" class="required">
                        <date-picker :date="beneficiaryBirthSet" v-on:date-get="beneficiaryDateBirth" />
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.benefisself==='0'" :span="12">
                    <el-form-item label="受益人职业：" prop="beneficiaryvocation">
                        <el-select v-model.trim="acctInfo.beneficiaryvocation" filterable placeholder="请选择职业">
                            <el-option
                                v-for="item in beneficiaryvocation"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.benefisself==='0'" :span="24">
                    <el-form-item label="受益人电话号码：" class="required" prop="beneficiarytelno">
                        <el-select
                            v-model="acctInfo.beneficiarytelnocycode"
                            placeholder="请选择国家码"
                            style="width:150px!important"
                        >
                            <el-option
                                v-for="item in beneficiarytelnocycode"
                                :key="item.subitem"
                                :label="item.subitemname+' '+item.subitem"
                                :value="item.subitem"
                            />
                        </el-select>
                        <el-select
                            v-if="acctInfo.beneficiarytelnocycode=='86'"
                            v-model="acctInfo.beneficiarytelnoareacode"
                            placeholder="请选择地区码"
                            style="width:150px!important"
                        >
                            <el-option
                                v-for="item in beneficiarytelnoareacode"
                                :key="item.subitem"
                                :label="item.subitemname+' '+item.subitem"
                                :value="item.subitem"
                            />
                        </el-select>
                        <el-input v-else v-model.trim="acctInfo.beneficiarytelnoareacodeinput" placeholder="请输入地区码" style="width:150px!important" />
                        <el-input v-model.trim="acctInfo.beneficiarytelno" style="margin-left:2px;width:300px" placeholder="请输入电话号码" :maxlength="8" />
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.benefisself==='0'" :span="24">
                    <country-city-select ref="benefAddressObj" v-model="benefAddressObj" required country-layout="user" v-on:input="getBenefAdrss"></country-city-select>
                </el-col>
                <el-col v-if="acctInfo.benefisself==='0'" :span="24">
                    <el-form-item label="通讯（现居）地址：" prop="beneficiaryaddr" class="required">
                        <el-input
                            v-model.trim="acctInfo.beneficiaryaddr"
                            placeholder="请输入（现居）通讯地址（例如：xx市xx省xx区xx街道xx号）"
                            :maxlength="32"
                            style="width: 87%;"
                        />
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.benefisself==='0'" :span="12">
                    <el-form-item label="电子邮箱：" prop="beneficiaryemail" class="required">
                        <el-input v-model.trim="acctInfo.beneficiaryemail" placeholder="请输入电子邮箱" :maxlength="32" />
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.benefisself==='0'" :span="12">
                    <el-form-item label="邮政编码：" prop="beneficiarypostcode" class="required">
                        <el-input v-model.trim="acctInfo.beneficiarypostcode" placeholder="请输入邮政编码" :maxlength="6" />
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.benefisself==='0'" :span="12">
                    <el-form-item label="受益人与持有人关系：" prop="benefrelation" class="required">
                        <el-input v-model.trim="acctInfo.benefrelation" placeholder="请输入受益人与持有人关系" />
                    </el-form-item>
                </el-col>


                <!--控制人信息-->
                <el-col style="padding-bottom:20px">
                    <div class="border"></div>
                </el-col>
                <el-col>
                    <span class="amount">实际控制人</span>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="控制人类型：" prop="actualisself" class="required">
                        <el-select v-model.trim="acctInfo.actualisself" placeholder="请选择受益人类型">
                            <el-option
                                v-for="item in actualisself"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.actualisself==='0'" :span="12">
                    <el-form-item label="账户实际控制人：" prop="actualctrlname" class="required">
                        <el-input v-model.trim="acctInfo.actualctrlname" placeholder="请输入控制人姓名" :maxlength="20" />
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.actualisself==='0'" :span="12">
                    <el-form-item label="控制人证件类型：" prop="actualctrlidtype" class="required">
                        <el-select v-model.trim="acctInfo.actualctrlidtype" placeholder="请选择控制人证件类型">
                            <el-option
                                v-for="item in actualctrlidtype"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.actualisself==='0'" :span="12">
                    <el-form-item label="控制人证件号码：" prop="actualctrlidcode" class="required">
                        <el-input v-model.trim="acctInfo.actualctrlidcode" placeholder="请输入控制人证件号码" :maxlength="32" />
                    </el-form-item>
                </el-col>
                <el-col v-if="(!fn && acctInfo.actualisself==='0') || (fn && !isactualctrlvalidateflag)" :span="12">
                    <el-form-item label="控制人证件有效期：" prop="actualctrlvalidate" class="required">
                        <date-picker :date="actualctrlDateSet" v-on:date-get="actualctrlDateInterval" />
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.actualisself==='0'" :span="12">
                    <el-form-item class="radio-list" label="性别：" prop="actualctrlsex">
                        <el-radio-group v-model.trim="acctInfo.actualctrlsex">
                            <el-radio v-for="item in actualctrlsex" :key="item.subitem" :label="item.subitem">
                                {{ item.subitemname }}
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.actualisself==='0'" :span="12">
                    <el-form-item label="控制人出生日期：" prop="actualctrlbirthday" class="required">
                        <date-picker :date="actualctrlBirthSet" v-on:date-get="actualctrlDateBirth" />
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.actualisself==='0'" :span="12">
                    <el-form-item label="控制人职业：" class="required" prop="actualctrlvocation">
                        <el-select v-model.trim="acctInfo.actualctrlvocation" filterable placeholder="请选择职业">
                            <el-option
                                v-for="item in actualctrlvocation"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.actualisself==='0'" :span="24">
                    <el-form-item label="控制人电话号码：" class="required" prop="actualctrltelno">
                        <el-select
                            v-model="acctInfo.actualctrltelnocycode"
                            placeholder="请选择国家码"
                            style="width:150px!important"
                        >
                            <el-option
                                v-for="item in telnocycode"
                                :key="item.subitem"
                                :label="item.subitemname+' '+item.subitem"
                                :value="item.subitem"
                            />
                        </el-select>
                        <el-select
                            v-if="acctInfo.actualctrltelnocycode=='86'"
                            v-model="acctInfo.actualctrltelnoareacode"
                            placeholder="请选择地区码"
                            style="width:150px!important"
                        >
                            <el-option
                                v-for="item in telnoareacode"
                                :key="item.subitem"
                                :label="item.subitemname+' '+item.subitem"
                                :value="item.subitem"
                            />
                        </el-select>
                        <el-input v-else v-model.trim="acctInfo.actualctrltelnoareacodeinput" placeholder="请输入地区码" style="width:150px!important" />
                        <el-input
                            v-model.trim="acctInfo.actualctrltelno"
                            style="margin-left:2px;width:300px"
                            placeholder="请输入电话号码"
                            :maxlength="8"
                        />
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.actualisself==='0'" :span="24">
                    <country-city-select ref="actualAddressObj" v-model="actualAddressObj" required country-layout="user" v-on:input="getActualAdrss"></country-city-select>
                </el-col>
                <el-col v-if="acctInfo.actualisself==='0'" :span="24">
                    <el-form-item label="通讯（现居）地址：" prop="actualctrladdr" class="required">
                        <el-input
                            v-model.trim="acctInfo.actualctrladdr"
                            placeholder="请输入（现居）通讯地址（例如：xx市xx省xx区xx街道xx号）"
                            :maxlength="32"
                            style="width: 87%;"
                        />
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.actualisself==='0'" :span="12">
                    <el-form-item label="电子邮箱：" prop="actualctrlemail" class="required">
                        <el-input v-model.trim="acctInfo.actualctrlemail" placeholder="请输入电子邮箱" :maxlength="32" />
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.actualisself==='0'" :span="12">
                    <el-form-item label="邮政编码：" prop="actualctrlpostcode" class="required">
                        <el-input v-model.trim="acctInfo.actualctrlpostcode" placeholder="请输入邮政编码" :maxlength="6" />
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.actualisself==='0'" :span="12">
                    <el-form-item label="控制人与持有人关系：" prop="actualrelation" class="required">
                        <el-input v-model.trim="acctInfo.actualrelation" placeholder="请输入控制人与持有人关系" />
                    </el-form-item>
                </el-col>


                <el-col v-if="isPwdCheck" :span="12">
                    <el-form-item label="交易密码：" prop="pwd" class="required">
                        <el-input
                            v-model.trim="acctInfo.pwd"
                            type="password"
                            placeholder="请输入交易密码"
                            :maxlength="16"
                        />
                        <span class="redemp-btn" v-on:click.prevent="$router.push({name: 'tradepwd'})"><span class="like-a">忘记密码？</span></span>
                    </el-form-item>
                </el-col>
                <el-col :span="24" class="btn-group">
                    <el-button type="primary" class="medium" v-on:click.prevent="submitInfo('acctInfo')">
                        保存
                    </el-button>
                    <el-button class="medium" v-on:click="$router.back()" v-text="'返回'+(acctInfo.usertype==='2'?'(点击其它菜单退出)':'')" />
                </el-col>
            </el-form>
        </el-row>
        <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="50%"
            :close-on-click-modal="false"
        >
            <el-checkbox v-model="checked" class="check-style">
            </el-checkbox>
            <span>本人承诺，以上所填信息发生重大变化时，本人将主动、及时进行信息更新，以便于贵机构重新评估本人风险承受能力。如本人未进行前述更新导致的投资损失以及其他法律后果由本人自行承担。</span>
            <span slot="footer" class="dialog-footer">
                <el-button v-on:click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" :disabled="!checked" v-on:click="gotoSub()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import format from "date-fns/format";
import datePicker from "@/components/form/datePicker.vue";
import countryCitySelect from "@/components/acct/countryCitySelect.vue";
export default {
    name: "UserInfo",
    components: {
        datePicker,
        countryCitySelect
    },
    props: {
        fn: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            isPwdCheck: false,
            acctInfo: {
                pwd: "",
                hometelnoareacode: "",
                telnoareacode: "",
                hometelnoareacodeinput: "",
                telnoareacodeinput: "",
                faxareacodeinput: "",
                beneficiarytelnoareacode: "",
                beneficiarytelnoareacodeinput: "",
                actualctrltelnoareacode: "",
                actualctrltelnoareacodeinput: "",
                actualrelation: "",
                benefrelation: "",
                annualincome: ""
            },
            livingAddressObj: {
                country: "CN",
                province: null,
                city: null,
                county: null
                //                address:null,
            },
            // 数据字典
            certTypes: [],
            delivertype: [],
            sex: [],
            vocationcode: [],
            educationlevel: [],
            deliverway: [],
            country: [],
            province: [],
            specialpersonflag: [],
            isdigniaryorceo: [],
            faxareacode: [],
            //受益人
            benefisself: [],
            beneficiarytype: [],
            beneficiarysex: [],
            beneficiaryvocation: [],
            beneficiarytelnocycode: [],
            beneficiarytelnoareacode: [],
            benefAddressObj: {
                country: "CN",
                province: null,
                city: null,
                county: null
                //                address:null,
            },
            //控制人
            actualisself: [],
            actualctrltype: [],
            actualctrlsex: [],
            actualctrlvocation: [],
            telnocycode: [],
            telnoareacode: [],
            actualAddressObj: {
                country: "CN",
                province: null,
                city: null,
                county: null
                //                address:null,
            },
            // 日期配置
            dateSet: { type: "3", max: "", dis: false },
            birthSet: { type: "1", min: "", dis: false },
            beneficiaryDateSet: { type: "3", max: "", val: "",text: "请选择证件有效期" },
            beneficiaryBirthSet: { type: "1", max: "", dis: false, val: "",text: "请选择出生日期" },
            actualctrlDateSet: { type: "3", max: "", val: "",text: "请选择证件有效期" },
            actualctrlBirthSet: { type: "1", max: "", dis: false, val: "",text: "请选择出生日期" },
            beneficChangeFlag: true,
            actualctrlChangeFlag: true,
            isMobile: false, // 是否有手机号码
            isDelivertype: true, // 是否有delivertype的值，仅对fn=true起作用
            isBirthdate: true, // 是否有birthdate的值，仅对fn=true起作用
            isCertexpdate: true, // 是否有certexpdate的值，仅对fn=true起作用
            isBeneficiarydateflag: true,
            isactualctrlvalidateflag: true,
            dialogVisible: false,
            checked: false,
            rules: {
                mobile: [
                    { required: true, message: "请输入手机号码", trigger: "blur" },
                    { validator: this.$util.validateMobile, trigger: "blur" }
                ],
                country: [
                    { required: true, message: "请选择国籍", trigger: "change" }
                ],
                province: [
                    { required: true, message: "请选择省份", trigger: "change" }
                ],
                birthdate: [
                    { required: true, validator: this.$util.validateDate, trigger: "blur" }
                ],
                vailddate: [
                    { validator: this.validateMin, trigger: "blur" },
                    { validator: this.$util.validateDate, trigger: "blur" }
                ],
                delivertype: [
                    { required: true, message: "请选对账单寄送周期", trigger: "change" }
                ],
                deliverway: [
                    { validator: this.validateDeliverway, trigger: "change" }
                ],
                address: [
                    { required: true, validator: this.validateAddress, trigger: "blur" }
                ],
                postcode: [
                    { validator: this.validatePostCode, trigger: "blur" }
                ],
                vocationsupple: [
                    { required: true, validator: this.validateVocationsupple, trigger: "blur" }
                ],
                educationlevel: [
                    { required: true, message: "请选择学历", trigger: "change" }
                ],
                occupation: [
                    { required: true, message: "请选择职业", trigger: "change" }
                ],
                email: [
                    { validator: this.validateEmail, trigger: "blur" }
                ],
                telno: [
                    { validator: this.$util.validateTelno, trigger: "blur" }
                ],
                hometelno: [
                    { validator: this.validateHomeTelno, trigger: "blur" }
                ],
                fax: [
                    { validator: this.validateFax, trigger: "blur" }
                ],
                faxareacode: [
                    { required: true, message: "请选择地区码", trigger: "change" }
                ],
                benefisself: [
                    { required: true, message: "请选择受益人类型", trigger: "change" }
                ],
                beneficiary: [
                    { validator: this.validateBeneficiary, trigger: "blur" }
                ],
                beneficiarytype: [
                    { validator: this.validateBeneficiarytype, trigger: "change" }
                ],
                beneficiaryno: [
                    { validator: this.validateBeneficiaryno, trigger: "blur" }
                ],
                beneficiarybirthday: [
                    { required: true, validator: this.$util.validateDate, trigger: "blur" }
                ],
                beneficiarydate: [
                    { validator: this.validateMin, trigger: "blur" },
                    { validator: this.$util.validateDate, trigger: "blur" }
                ],
                beneficiarysex: [
                    {required: true, message: "请选择性别", trigger: "change"}
                ],
                beneficiaryvocation: [
                    { required: true, message: "请选择职业", trigger: "change" }
                ],
                beneficiaryemail: [
                    { validator: this.$util.validateEmail, trigger: "blur" }
                ],
                beneficiarypostcode: [
                    { validator: this.$util.validatePostCode, trigger: "blur" }
                ],
                beneficiaryaddr: [
                    { required: true, validator: this.validateAddress, trigger: "blur" }
                ],
                actualisself: [
                    { required: true, message: "请选择控制人类型", trigger: "change" }
                ],
                actualctrlname: [
                    { validator: this.validateActualctrlname, trigger: "blur" }
                ],
                actualctrlsex: [
                    {required: true, message: "请选择性别", trigger: "change"}
                ],
                actualctrlidtype: [
                    { validator: this.validateActualctrlidtype, trigger: "change" }
                ],
                actualctrlidcode: [
                    { validator: this.validateActualctrl, trigger: "blur" }
                ],
                actualctrlbirthday: [
                    { required: true, validator: this.$util.validateDate, trigger: "blur" }
                ],
                actualctrlvalidate: [
                    { validator: this.validateMin, trigger: "blur" },
                    { validator: this.$util.validateDate, trigger: "blur" }
                ],
                actualctrlvocation: [
                    { required: true, message: "请选择职业", trigger: "change" }
                ],
                actualctrlpostcode: [
                    { validator: this.validatePostCode2, trigger: "blur" }
                ],
                actualctrlemail: [
                    { validator: this.validateEmail, trigger: "blur" }
                ],
                assetssource: [
                    { validator: this.validateAssetssource, trigger: "blur" }
                ],
                actualrelation: [
                    { required: true, message: "请输入控制人与持有人关系", trigger: "blur" }
                ],
                beneficiarytelno: [
                    { validator: this.$util.validateFaxNum, trigger: "blur" }
                ],
                actualctrltelno: [
                    { validator: this.$util.validateFaxNum, trigger: "blur" }
                ],
                actualctrladdr: [
                    { required: true, validator: this.validateAddress, trigger: "blur" }
                ],
                pwd: [
                    { required: true, message: "请输入交易密码", trigger: "blur" }
                ],
                //                annualincome: [
                //                    { required: true, message: "请输入年收入", trigger: "blur" }
                //                ],
                annualincome: [
                    {required: true,validator: this.checkAnnualincome,mes: "年收入", trigger: "blur"}
                ],
                specialpersonflag: [
                    { required: true, message: "请选择特定自然人标识", trigger: "change" }
                ],
                isdigniaryorceo: [
                    { required: true, message: "请选择受益人类型", trigger: "change" }
                ],
                benefrelation: [
                    { required: true, message: "请输入受益人与持有人关系", trigger: "blur" }
                ]
            },
            ocrOnOff: false,
            hasOcr: "0",
            ocrStatus: false,
            ocrBtnInfo: "更新证件信息",
            ocrUploadFlag: ""
        };
    },
    watch: {
        "acctInfo.delivertype" (val) {
            if (val === "1") {
                this.acctInfo.deliverway = "00000000";
            }
        },
        "acctInfo.occupation" (val) {
            if (val !== "06") {
                this.acctInfo.vocationsupple = "";
            }
        },
        "acctInfo.benefisself" (val) {
            if (this.beneficChangeFlag) {
                this.beneficChangeFlag = !this.beneficChangeFlag;
                return false;
            }
            this.acctInfo.beneficiary = "";
            this.acctInfo.beneficiarytype = "";
            this.acctInfo.beneficiaryno = "";
            this.acctInfo.beneficiarydate = "";
            this.acctInfo.beneficiarysex = "";
            this.acctInfo.beneficiarybirthday = "";
            this.acctInfo.beneficiaryvocation = "";
            this.acctInfo.beneficiarytelnocycode = "";
            this.acctInfo.beneficiarytelnoareacode = "";
            this.acctInfo.beneficiarytelnoareacodeinput = "";
            this.acctInfo.beneficiarytelno = "";
            this.acctInfo.beneficiarycountry = "";
            this.acctInfo.beneficiaryaddrprovince = "";
            this.acctInfo.beneficiaryaddrcity = "";
            this.acctInfo.beneficiaryaddrcounty = "";
            this.acctInfo.beneficiaryaddr = "";
            this.acctInfo.beneficiaryemail = "";
            this.acctInfo.beneficiarypostcode = "";
            this.acctInfo.benefrelation = "";
            this.$set(this.beneficiaryDateSet, "val", "");
            this.$set(this.beneficiaryBirthSet, "val", "");
            this.$set(this.beneficiaryDateSet, "time", new Date().getTime());
            this.$set(this.beneficiaryBirthSet, "time", new Date().getTime());
        },
        "acctInfo.actualisself" (val) {
            if (this.actualctrlChangeFlag) {
                this.actualctrlChangeFlag = !this.actualctrlChangeFlag;
                return false;
            }
            this.acctInfo.actualctrl = "";
            this.acctInfo.actualctrlname = "";
            this.acctInfo.actualctrltype = "";
            this.acctInfo.actualctrlno = "";
            this.acctInfo.actualctrldate = "";
            this.acctInfo.actualctrlsex = "";
            this.acctInfo.actualctrlbirthday = "";
            this.acctInfo.actualctrlvocation = "";
            this.acctInfo.actualctrltelnocycode = "";
            this.acctInfo.actualctrltelnoareacode = "";
            this.acctInfo.actualctrltelnoareacodeinput = "";
            this.acctInfo.actualctrltelno = "";
            this.acctInfo.actualctrlcountry = "";
            this.acctInfo.actualctrladdrprovince = "";
            this.acctInfo.actualctrladdrcity = "";
            this.acctInfo.actualctrladdrcounty = "";
            this.acctInfo.actualctrladdr = "";
            this.acctInfo.actualctrlemail = "";
            this.acctInfo.actualctrlpostcode = "";
            this.acctInfo.actualrelation = "";
            this.acctInfo.actualctrlvalidate = "";
            this.acctInfo.actualctrlidcode = "";
            this.acctInfo.actualctrlidtype = "";
            this.$set(this.actualctrlDateSet, "val", "");
            this.$set(this.actualctrlBirthSet, "val", "");
            this.$set(this.actualctrlDateSet, "time", new Date().getTime());
            this.$set(this.actualctrlBirthSet, "time", new Date().getTime());
        },
        "acctInfo.telnocycode"(val){
            if(val != "86"){
                this.acctInfo.telnoareacodeinput = this.acctInfo.telnoareacode;
            }
        },
        "acctInfo.telnoareacodeinput"(val){
            this.acctInfo.telnoareacode = this.acctInfo.telnoareacodeinput;
        },
        "acctInfo.hometelnocycode"(val){
            if(val != "86"){
                this.acctInfo.hometelnoareacodeinput = this.acctInfo.hometelnoareacode;
            }
        },
        "acctInfo.hometelnoareacodeinput"(val){
            this.acctInfo.hometelnoareacode = this.acctInfo.hometelnoareacodeinput;
        },
        "acctInfo.faxcycode"(val){
            if(val != "86"){
                this.acctInfo.faxareacodeinput = this.acctInfo.faxareacode;
            }
        },
        "acctInfo.faxareacodeinput"(val){
            this.acctInfo.faxareacode = this.acctInfo.faxareacodeinput;
        },
        "acctInfo.beneficiarytelnocycode"(val){
            if(val != "86"){
                this.acctInfo.beneficiarytelnoareacodeinput = this.acctInfo.beneficiarytelnoareacode;
            }
        },
        "acctInfo.beneficiarytelnoareacodeinput"(val){
            this.acctInfo.beneficiarytelnoareacode = this.acctInfo.beneficiarytelnoareacodeinput;
        },
        "acctInfo.actualctrltelnocycode"(val){
            if(val != "86"){
                this.acctInfo.actualctrltelnoareacodeinput = this.acctInfo.actualctrltelnoareacode;
            }
        },
        "acctInfo.actualctrltelnoareacodeinput"(val){
            this.acctInfo.actualctrltelnoareacode = this.acctInfo.actualctrltelnoareacodeinput;
        }
    },
    created () {
        const birthmax = this.$util.getBeginDate(format(new Date(), "YYYYMMDD"), 18, true);
        this.hasOcr = this.$cache.getParams("hasocr");
        this.birthSet.max = this.$util.fmtDate(birthmax);
        this.birthSet.min = this.$util.fmtDate("19000101");
        // 重新提取最小日期
        const conf = this.$util.getConfig().const;
        const info = this.$cache.getUser();
        this.beneficiaryDateSet.max = this.$util.fmtDate(conf.CARD_DATE_MAX);
        this.beneficiaryBirthSet.max = this.$util.fmtDate(birthmax);
        this.beneficiaryBirthSet.min = this.$util.fmtDate("19000101");
        this.$set(this.beneficiaryDateSet, "val", format(info.beneficiarydate,"YYYY-MM-DD"));
        this.$set(this.beneficiaryDateSet, "time", new Date().getTime());
        this.$set(this.beneficiaryBirthSet, "val", format(info.beneficiarybirthday,"YYYY-MM-DD"));
        this.$set(this.beneficiaryBirthSet, "time", new Date().getTime());
        this.actualctrlDateSet.max = this.$util.fmtDate(conf.CARD_DATE_MAX);
        this.actualctrlBirthSet.max = this.$util.fmtDate(birthmax);
        this.actualctrlBirthSet.min = this.$util.fmtDate(conf.BIRTH_DATE);
        this.$set(this.actualctrlDateSet, "val", format(info.actualctrlvalidate,"YYYY-MM-DD"));
        this.$set(this.actualctrlDateSet, "time", new Date().getTime());
        this.$set(this.actualctrlBirthSet, "val", format(info.actualctrlbirthday,"YYYY-MM-DD"));
        this.$set(this.actualctrlBirthSet, "time", new Date().getTime());
        this.isPwdCheck = this.$cache.getPwdCheck("B1");
        const _x = {};
        for (let item in info) {
            _x[item] = info[item].trim();
        }
        if (!_x.delivertype) {
            this.isDelivertype = false;
        }
        if (!_x.birthdate) {
            this.isBirthdate = false;
        }
        if (!_x.vailddate || _x.certexpired === "1") {
            this.isCertexpdate = false;
        }
        if (_x.benefexpdate === "1") {
            this.isBeneficiarydateflag = false;
        }
        if (_x.actualctrlexp === "1") {
            this.isactualctrlvalidateflag = false;
        }
        if (_x.mobile) {
            this.isMobile = true;
        }
        // 国籍默认中国
        if (!_x.country) {
            _x.country = "CN";
        }
        if(this.$route.query){
            _x.custname = this.$route.query.custname || _x.custname;
            _x.certificateno = this.$route.query.certificateno || _x.certificateno;
            _x.vailddate = this.$route.query.vailddate || _x.vailddate;
            _x.birthdate = this.$route.query.birthdate || _x.birthdate;
            if(_x.certTypeText === "身份证" && this.$route.query.certificateno){
                _x.sex = (this.$route.query.certificateno.substr(16,1) % 2).toString();
            }
            if(_x.beneficiarytype === "身份证" && this.$route.query.beneficiaryno && _x.benefisself === "1"){
                _x.beneficiarysex = (this.$route.query.beneficiaryno.substr(16,1) % 2).toString();
            }
            if(_x.beneficiarytype === "身份证" && this.$route.query.actualctrlidcode && _x.actualisself === "1"){
                _x.actualctrlsex = (this.$route.query.actualctrlidcode.substr(16,1) % 2).toString();
            }
            const _this = this;
            if(this.$route.query.birthdate){
                const _date = this.$util.getBeginDate(format(new Date(),"YYYYMMDD"),18,true);
                if(Number(this.$route.query.birthdate) >= Number(_date)){
                    _this.$alert("根据您的证件信息，您属于未成年人，暂时无法开户！", "", {
                        confirmButtonText: "确定",
                        type: "warning",
                        callback: action => {
                            _this.$router.push({name: "info"});
                        }
                    }).then(() => {
                        return false;
                    }).catch(() => {
                        return false;
                    });
                }
            }
        }

        this.acctInfo = Object.assign({}, this.acctInfo, _x);
        this.mobileBind(this.acctInfo);
        this.dateSet.val = this.acctInfo.vailddate ? this.$util.fmtDate(this.acctInfo.vailddate) : "";
        this.dateSet.max = this.$util.fmtDate(conf.CARD_DATE_MAX);
        this.birthSet.min = this.$util.fmtDate(conf.BIRTH_DATE);
        // :TODO: 测试瑞年
        this.birthSet.max = this.$util.fmtDate(
            format(new Date(), "YYYYMMDD") - 180000
        );

        this.certTypes = this.$cache.getDict("130007");
        this.delivertype = this.$cache.getDict("110046");
        this.sex = this.$cache.getDict("110059").reverse();
        this.beneficiarysex = this.$cache.getDict("110059").reverse();
        this.actualctrlsex = this.$cache.getDict("110059").reverse();
        this.vocationcode = this.$cache.getDict("150141");
        this.deliverway = this.$cache.getDict("100013");
        this.educationlevel = this.$cache.getDict("100014");
        this.specialpersonflag = this.$cache.getDict("120200"); //特定自然人标识
        this.isdigniaryorceo = this.$cache.getDict("120200");
        this.country = this.$util.changeArrIndex(this.$cache.getDict("120109"),"CN");
        this.province = this.$cache.getDict("120122");
        //受益人
        this.beneficiaryvocation = this.$cache.getDict("150141");
        // this.beneficiarytelnocycode = this.$cache.getDict("150136"); //国家码
        this.beneficiarytelnocycode = this.$util.changeArrIndex(this.$cache.getDict("150136"), "86");
        this.beneficiarytelnoareacode = this.$cache.getDict("150137");
        //控制人
        this.actualctrlvocation = this.$cache.getDict("150141");
        // this.telnocycode = this.$cache.getDict("150136"); //国家码
        this.telnocycode = this.$util.changeArrIndex(this.$cache.getDict("150136"), "86");
        this.telnoareacode = this.$cache.getDict("150137");
        this.benefisself = this.$cache.getDict("120137");
        this.beneficiarytype = this.$cache.getDict("130007");
        this.actualisself = this.$cache.getDict("120137");
        this.actualctrlidtype = this.$cache.getDict("130007");
        this.getOcrOpenStatus();
        this.initAddress();
        this.initBenefAddress();
        this.initActualAddress();
    },
    methods: {
        initAddress(){
            this.livingAddressObj["country"] = this.acctInfo["livingcountry"];
            this.livingAddressObj["province"] = this.acctInfo["livingaddressprovince"];
            this.livingAddressObj["city"] = this.acctInfo["livingaddresscity"];
            this.livingAddressObj["county"] = this.acctInfo["livingaddresscounty"];
        },
        getAdrss(data){
            this.acctInfo.address = data.address;
            this.acctInfo.livingaddress = data.address;
            if (data.country !== "CN") {
                this.livingAddressObj["province"] = "";
                this.livingAddressObj["city"] = "";
                this.livingAddressObj["county"] = "";
            }
        },
        //受益人国家、省、市、县
        initBenefAddress(){
            this.benefAddressObj["country"] = this.acctInfo["beneficiarycountry"];
            this.benefAddressObj["province"] = this.acctInfo["beneficiaryaddrprovince"];
            this.benefAddressObj["city"] = this.acctInfo["beneficiaryaddrcity"];
            this.benefAddressObj["county"] = this.acctInfo["beneficiaryaddrcounty"];
        },
        getBenefAdrss(data){
            this.acctInfo.beneficiaryaddr = data.address;
            if (data.country !== "CN") {
                this.benefAddressObj["province"] = "";
                this.benefAddressObj["city"] = "";
                this.benefAddressObj["county"] = "";
            }
        },
        //控制人国家、省、市、县
        initActualAddress(){
            this.actualAddressObj["country"] = this.acctInfo["actualctrlcountry"];
            this.actualAddressObj["province"] = this.acctInfo["actualctrladdrprovince"];
            this.actualAddressObj["city"] = this.acctInfo["actualctrladdrcity"];
            this.actualAddressObj["county"] = this.acctInfo["actualctrladdrcounty"];
        },
        setAddress(){
            this.acctInfo["livingcountry"] = this.livingAddressObj["country"];
            this.acctInfo["livingaddressprovince"] = this.livingAddressObj["province"];
            this.acctInfo["livingaddresscity"] = this.livingAddressObj["city"];
            this.acctInfo["livingaddresscounty"] = this.livingAddressObj["county"];

            this.acctInfo["beneficiarycountry"] = this.acctInfo["benefisself"] == "0" ? this.benefAddressObj["country"] : "";
            this.acctInfo["beneficiaryaddrprovince"] = this.acctInfo["benefisself"] == "0" ? this.benefAddressObj["province"] : "";
            this.acctInfo["beneficiaryaddrcity"] = this.acctInfo["benefisself"] == "0" ? this.benefAddressObj["city"] : "";
            this.acctInfo["beneficiaryaddrcounty"] = this.acctInfo["benefisself"] == "0" ? this.benefAddressObj["county"] : "";

            this.acctInfo["actualctrlcountry"] = this.acctInfo["actualisself"] == "0" ? this.actualAddressObj["country"] : "";
            this.acctInfo["actualctrladdrprovince"] = this.acctInfo["actualisself"] == "0" ? this.actualAddressObj["province"] : "";
            this.acctInfo["actualctrladdrcity"] = this.acctInfo["actualisself"] == "0" ? this.actualAddressObj["city"] : "";
            this.acctInfo["actualctrladdrcounty"] = this.acctInfo["actualisself"] == "0" ? this.actualAddressObj["county"] : "";
        },
        getActualAdrss(data){
            this.acctInfo.actualctrladdr = data.address;
            if (data.country !== "CN") {
                this.actualAddressObj["province"] = "";
                this.actualAddressObj["city"] = "";
                this.actualAddressObj["county"] = "";
            }
        },
        checkAddressInfo(){
            let hasLivingAddrInfo = true;
            if(this.acctInfo.livingcountry === this.$const.CN){
                hasLivingAddrInfo = !!this.acctInfo.livingaddressprovince && !!this.acctInfo.livingaddress && !!this.acctInfo.livingaddresscity;
            }else{
                hasLivingAddrInfo = !!this.acctInfo.address;
            }
            if(!hasLivingAddrInfo){
                this.$alert("请完善现居地址(国家/地区-省-市-县)信息！","提示");
                return false;
            }
            return true;
        },
        checkBenefActualInfo(){
            let hasBenefInfo = true;
            let hasCtrlInfo = true;
            if(this.acctInfo.benefisself === "0"){
                let excludeitems = ["county"];//有些地方没有县
                if(this.acctInfo.beneficiarycountry !== this.$const.CN){
                    excludeitems = excludeitems.concat(["province","city","county"]);
                }
                this.benefAddressObj.address = this.acctInfo.beneficiaryaddr;
                hasBenefInfo = this.$util.checkInfoFilled(this.benefAddressObj,excludeitems);
            }
            if(this.acctInfo.actualisself === "0"){
                let excludeitems = ["county","actualAddressObj"];//有些地方没有县
                if(this.acctInfo.actualctrlcountry !== this.$const.CN){
                    excludeitems = excludeitems.concat(["province","city","county"]);
                }
                this.actualAddressObj.address = this.acctInfo.actualctrladdr;
                hasCtrlInfo = this.$util.checkInfoFilled(this.actualAddressObj,excludeitems);
            }

            if(!hasCtrlInfo) {
                this.$alert("请完善实际控制人地址(国家/地区-省-市-县)信息！","提示");
                return false;
            }
            if(!hasBenefInfo) {
                this.$alert("请完善实际受益人地址(国家/地区-省-市-县)信息！","提示");
                return false;
            }
            return true;
        },
        mobileBind (info) {
            if (info.mobile.length != 11 && info.needfillcustinfo == "0"){
                this.$alert("您暂未绑定手机号，请前往绑定！","手机号绑定",{
                    confirmButttonText: "前往",
                    showCancelButton: false,
                    type: "warning",
                    callback: action => {
                        this.$router.push({ name: "bindmobile" });
                    }
                }).then(res => {

                });
            }
        },
        dateInterval (val) {
            this.acctInfo.vailddate = val !== null ? val.replace(/-/g, "") : "";
            this.$refs.acctInfo.validateField("vailddate");
        },
        dateBirth (val) {
            this.acctInfo.birthdate = val !== null ? val.replace(/-/g, "") : "";
        },
        //受益人出生日期
        beneficiaryDateBirth (val){
            this.acctInfo.beneficiarybirthday = val !== null ? val.replace(/-/g, "") : "";
        },
        //受益人证件有效期
        beneficiaryDateInterval (val) {
            this.acctInfo.beneficiarydate = val !== null ? val.replace(/-/g, "") : "";
            this.$refs.acctInfo.validateField("beneficiarydate");
        },
        //控制人出生日期
        actualctrlDateBirth (val){
            this.acctInfo.actualctrlbirthday = val !== null ? val.replace(/-/g, "") : "";
        },
        //控制人证件有效期
        actualctrlDateInterval (val) {
            this.acctInfo.actualctrlvalidate = val !== null ? val.replace(/-/g, "") : "";
            this.$refs.acctInfo.validateField("actualctrlvalidate");
        },
        validateAddress (rule, value, callback) {
            /* if (this.acctInfo.deliverway === "1" && !value) { */
            if (!value) {
                callback(new Error("请输入联系地址"));
            } else {
                callback();
            }
        },
        validateLocation(rule, value, callback){
            if(this.acctInfo.country === "CN"){
                if(this.$util.isEmpty(value)){
                    callback(new Error("请选择省份"));
                }else{
                    callback();
                }
            }else{
                callback();
            }
        },
        validateAssetssource(rule, value, callback){
            if(this.acctInfo.specialpersonflag === "1" || this.acctInfo.specialpersonflag === "2" || this.acctInfo.specialpersonflag === "3" || this.acctInfo.specialpersonflag === "4"){
                if(this.$util.isEmpty(value)){
                    callback(new Error("请输入收入来源"));
                }
            }
            if(!this.$util.isEmpty(value)){
                this.$util.validateGeneral(rule, value, callback,"收入来源");
            }else{
                callback();
            }
        },
        validateBeneficiary(rule, value, callback){
            if(this.acctInfo.benefisself === "0"){
                if(this.$util.isEmpty(value)){
                    callback(new Error("请输入受益人姓名"));
                }else{
                    callback();
                }
            }else{
                callback();
            }
        },
        validateBeneficiarytype(rule, value, callback){
            if(this.acctInfo.benefisself === "0"){
                if(this.$util.isEmpty(value)){
                    callback(new Error("请选择受益人证件类型"));
                }else{
                    callback();
                }
            }else{
                callback();
            }
        },
        validateBeneficiaryno(rule, value, callback){
            if(this.acctInfo.benefisself === "0"){
                if(this.$util.isEmpty(value)){
                    callback(new Error("请输入受益人证件号码"));
                }else{
                    this.$util.validateCertNo(rule, value, callback, this.acctInfo.beneficiarytype);
                }
            }else{
                callback();
            }
        },
        validateBeneficiarydate(rule, value, callback){
            if(this.acctInfo.benefisself === "0"){
                if(this.$util.isEmpty(value)){
                    callback(new Error("请选择受益人证件有效期"));
                }else{
                    if (Number(value) < Number(format(new Date(),"YYYYMMDD"))) {
                        callback(new Error("受益人有效期必须大于当前日期，请重新选择"));
                    } else {
                        callback();
                    }
                }
            }else{
                callback();
            }
        },
        validateActualctrlname(rule, value, callback){
            if(this.acctInfo.actualisself === "0"){
                if(this.$util.isEmpty(value)){
                    callback(new Error("请输入控制人姓名"));
                }else{
                    callback();
                }
            }else{
                callback();
            }
        },
        validateActualctrlidtype(rule, value, callback){
            if(this.acctInfo.actualisself === "0"){
                if(this.$util.isEmpty(value)){
                    callback(new Error("请选择控制人证件类型"));
                }else{
                    callback();
                }
            }else{
                callback();
            }
        },
        validateActualctrl(rule, value, callback){
            if(this.acctInfo.actualisself === "0"){
                if(this.$util.isEmpty(value)){
                    callback(new Error("请输入控制人证件号码"));
                }else{
                    this.$util.validateCertNo(rule, value, callback, this.acctInfo.actualctrlidtype);
                }
            }else{
                callback();
            }
        },
        validatePostCode (rule, value, callback) {
            if (this.acctInfo.deliverway === "1" || value !== "") {
                this.$util.validatePostCode(rule, value, callback);
            } else {
                callback();
            }
        },
        validatePostCode2 (rule, value, callback) {
            this.$util.validatePostCode(rule, value, callback);
        },
        validateVocationsupple (rule, value, callback) {
            if (this.acctInfo.occupation === "06" && !value) {
                callback(new Error("请输入职业补充信息"));
            } else {
                callback();
            }
        },
        validateDeliverway (rule, value, callback) {
            if (value === "" || value === "00000000") {
                callback(new Error("对账单寄送方式"));
            } else {
                callback();
            }
        },
        validateTelno (rule, value, callback) {
            if (this.acctInfo.telno !== "") {
                this.$util.validateFaxNum(rule, value, callback);
            } else {
                callback();
            }
        },
        validateHomeTelno (rule, value, callback) {
            if (this.acctInfo.hometelno !== "") {
                this.$util.validateFaxNum(rule, value, callback);
            } else {
                callback();
            }
        },
        validateFax (rule, value, callback) {
            if (this.acctInfo.deliverway === "2") {
                this.$util.validateFaxNum(rule, value, callback);
            } else {
                callback();
            }
        },
        validateEmail (rule, value, callback) {
            if (this.acctInfo.deliverway === "3" || value !== "") {
                this.$util.validateEmail(rule, value, callback);
            } else {
                callback();
            }
        },
        checkAnnualincome (rule, value, callback) {
            this.$util.validateInteger(rule, value, callback);
        },
        gotoSub () {
            const _this = this;
            _this.dialogVisible = false;
            if(this.acctInfo.birthdate){
                const _date = this.$util.getBeginDate(format(new Date(),"YYYYMMDD"),18,true);
                if(Number(this.acctInfo.birthdate) >= Number(_date)){
                    _this.$alert("根据您的证件信息，您属于未成年人，暂时无法开户！", "", {
                        confirmButtonText: "确定",
                        type: "warning",
                        callback: action => {
                            _this.$router.push({name: "info"});
                        }
                    }).then(() => {
                        return false;
                    }).catch(() => {
                        return false;
                    });
                    return;
                }
            }
            let _obj = _this.$util.getObjParam(_this.acctInfo, "annualincome,province,vailddate,specialpersonflag,country,occupation,delivertype,deliverway,sex,educationlevel,postcode,email,hometelno,hometelnoareacode,hometelnocycode,telno,telnoareacode,telnocycode,fax,faxcycode,faxareacode,address,remark,birthdate,pwd,benefisself,livingaddressprovince,livingaddresscity,livingaddresscounty,assetssource,beneficiary,beneficiarytype,beneficiaryno,beneficiarydate,beneficiarysex,beneficiarybirthday," +
                "beneficiaryvocation,beneficiarytelnocycode,beneficiarytelnoareacode,beneficiarytelno,beneficiarycountry,beneficiaryaddrprovince,beneficiaryaddrcity,beneficiaryaddrcounty," +
                "beneficiaryaddr,beneficiaryemail,beneficiarypostcode,benefrelation,actualisself,actualctrlname,actualctrlidtype,actualctrlidcode,actualctrlvalidate,actualctrlsex,actualctrlbirthday,actualctrlvocation," +
                "actualctrltelnocycode,actualctrltelnoareacode,actualctrltelno,actualctrlcountry,actualctrladdrprovince,actualctrladdrcity,actualctrladdrcounty,actualctrladdr,actualctrlemail,actualctrlpostcode,actualrelation");
            _obj.isdigniaryorceo = _this.acctInfo.specialpersonflag;
            _obj.livingcountry = _this.acctInfo.livingcountry;
            _obj.livingaddress = _this.acctInfo.address;
            _obj.country = _this.acctInfo.country;
            _obj.otherprovince = _this.acctInfo.province;
            _obj.location = _obj.country === "CN" ? this.$cache.getDict("120122",_obj.livingaddressprovince) : this.$cache.getDict("110049",_obj.country);
            _obj.belongregion = _obj.country === "CN" ? "中国" : "外国";
            if (!_this.isMobile) {
                _obj.mobile = _this.acctInfo.mobile;
            }
            _obj.tradepwd = this.$util.enc(_obj.pwd);
            if(_obj.occupation === "06"){
                _obj.vocationsupple = _this.acctInfo.vocationsupple;
            }
            _this.$util.request("acct/common/riskycust", {certificatetype: _this.acctInfo.certificatetype, invtp: "1"}, "GET").then(res => {
                if (res.data) {
                    if (res.data[0].flag === "1") {
                        if (_this.fn) {
                            _this.$alert("账号为风险客户，请联系客服进行修改操作!", "信息提示", {
                                confirmButtonText: "确定",
                                type: "warning",
                                callback: action => {
                                    this.$router.push({ name: "modifyinfo" });
                                }
                            }).then(() => {
                                return false;
                            }).catch(() => {
                                return false;
                            });
                            return false;
                        }
                        _this.$message.warning("账号为风险客户，请联系客服进行修改操作!");
                        return false;
                    } else {
                        _this.$util.request("acct/cust/profile", _obj, "PUT").then(res => {
                            if (res.data) {
                                let _x = Object.assign({}, _this.acctInfo, {pwd: ""});
                                _x.certexpired = "0";
                                _x.benefexpdate = "0";
                                _x.actualctrlexp = "0";
                                _x.needfillcustinfo = "";
                                _this.$store.dispatch("setInfo", _x).then(() => {
                                    let _param = {
                                        "isdigniaryorceo": _this.acctInfo.specialpersonflag,
                                        "assetssource": _this.acctInfo.assetssource
                                    };
                                    _this.$util.adddigniaryorceo(_param);
                                    _this.$message({
                                        type: "success",
                                        message: "个人信息已更新成功" + (_this.fn ? "" : "，3秒后回到个人信息页面"),
                                        onClose: function () {
                                            if (_this.fn) { _this.$emit("fn-back", true); } else {
                                                _this.$router.push({ name: "info" });
                                            }
                                        }
                                    });
                                });
                            }
                        });
                    }
                }
            });
        },
        /* 提交表单数据，校验用户信息 */
        submitInfo (formName) {
            const _this = this;
            // this.$util.highriskareaquery(this.acctInfo.country,this.acctInfo.province,res => {
            //     if(res == "1") {
            //         this.$alert("尊敬的客户您好，您的受益人所在的国籍为反洗钱法规确认的高危地区，请您联系客服修改！");
            //         return;
            //     }
            // })
            if (this.ocrUploadFlag === "5") {
                this.$alert("请先上传证件照");
                return;
            }
            if((this.acctInfo.deliverway === "2" && this.acctInfo.faxcycode === "") || (this.acctInfo.benefisself === "0" && this.acctInfo.beneficiarytelnocycode === "") || (this.acctInfo.actualisself === "0" && this.acctInfo.actualctrltelnocycode === "") || (this.acctInfo.hometelno != "" && this.acctInfo.hometelnocycode === "") || (this.acctInfo.telno != "" && this.acctInfo.telnocycode === "") || (this.acctInfo.fax != "" && this.acctInfo.faxcycode === "")){
                this.$alert("请选择国家码");
                return;
            }
            if((this.acctInfo.deliverway === "2" && this.acctInfo.faxcycode === "86" && this.acctInfo.faxareacode === "") || (this.acctInfo.beneficiarytelnocycode === "86" && this.acctInfo.beneficiarytelnoareacode === "")
                || (this.acctInfo.actualctrltelnocycode === "86" && this.acctInfo.actualctrltelnoareacode === "") || (this.acctInfo.hometelno != "" && this.acctInfo.hometelnoareacode === "") || (this.acctInfo.telno != "" && this.acctInfo.telnoareacode === "") || (this.acctInfo.fax != "" && this.acctInfo.faxareacode === "")){
                this.$alert("请选择地区码！");
                return;
            }
            _this.setAddress();
            if(!this.checkAddressInfo() || !this.checkBenefActualInfo()){
                return;
            }
            _this.$refs[formName].validate(valid => {
                if (valid) {
                    _this.dialogVisible = true;
                } else {
                    return false;
                }
            });
        },
        // 再次校验证件号码
        checkCertNoAgain () {
            this.$refs.acctInfo.validateField("certNo");
        },
        //检查存量客户性别、证件有效期、出生日期是否为空
        checkUser (vailddate,info) {
            let _x = "";
            if(!this.$util.isEmpty(vailddate)){
                if(Number(format(new Date(),"YYYYMMDD")) > Number(vailddate)){
                    _x += "证件有效期已过期";
                }
            }
            if(this.$util.isEmpty(info.sex)){
                if(!this.$util.isEmpty(_x)){
                    _x += "，性别为空";
                }
                else{
                    _x += "性别为空";
                }
            }
            if(this.$util.isEmpty(vailddate)){
                if(_x != ""){
                    _x += "，证件有效期为空";
                }
                else{
                    _x += "证件有效期为空";
                }
            }
            if(this.$util.isEmpty(info.birthdate)){
                if(_x != ""){
                    _x += "，出生日期为空";
                }
                else{
                    _x += "出生日期为空";
                }
            }
            return _x;
        },
        getOcrOpenStatus () {
            const _this = this;
            const _x = this.$util.src("/acct/ocr/check",{},true);
            const _data = {};
            this.$req({
                method: "GET",
                url: _x,
                timeout: 20000,
                data: _data
            }).then(res => {
                if (res.code === "0000000") {
                    if (res.record[0][0].isOpenOcr == "1") {
                        _this.ocrOnOff = true;
                        // ump开关(走ocr还是人工审核)
                        if ( _this.acctInfo.certificatetype == "0" && _this.hasOcr == "1") {
                            _this.dateSet.dis = true;
                            _this.birthSet.dis = true;
                            const info = _this.$cache.getUser();
                            /* _this.dateSet.dis = true; */
                            let _val = "";
                            if(_this.$route.query){
                                _val = _this.$route.query.vailddate;
                            }
                            let vailddate = _val || info.vailddate;
                            let _x = _this.checkUser (vailddate,info);
                            if(_x != "" && _this.$cache.getUser().usertype !== "2"){
                                this.$alert(_x + ",请重新上传证件！", "信息提示", {
                                    confirmButtonText: "重新上传",
                                    callback: action => {
                                        _this.$router.push({ name: "ocrinfoupd", query: { certificatetype: _this.acctInfo.certificatetype } });
                                    }
                                });
                                return;
                            }
                        }
                        _this.ocrUploadFlag = res.record[0][0].ocrUploadFlag;
                        if (_this.ocrUploadFlag != "0" && _this.ocrUploadFlag != "5") {
                            _this.ocrStatus = true;
                            _this.ocrBtnInfo = "已上传";
                        }
                    }
                } else {
                    _this.$message.error(res.msg);
                }
            }).catch(() => { });
        },
        gotoUpdOcr () {
            const _this = this;
            this.$router.push({ name: "ocrinfoupd", query: { certificatetype: _this.acctInfo.certificatetype } });
        },
        validateMin (rule, value, callback) {
            if (Number(value) < Number(format(new Date(),"YYYYMMDD"))) {
                callback(new Error("证件有效期必须大于当前日期，请重新选择"));
            } else {
                callback();
            }
        },
        specificnaturalper(){
            var _param = {
                "invtp": "1",
                "certificatetype": this.acctInfo.certificatetype,
                "custfullname": this.acctInfo.custname,
                "action": "Q"
            };
            this.$util.specificnaturalper(_param,res =>{
                if(res != null){
                    for(let i in this.isdigniaryorceo){
                        if(this.isdigniaryorceo[i].subitem == "0" || this.isdigniaryorceo[i].subitem == "A"){
                            this.isdigniaryorceo.splice(i,0);
                            i--;
                        }
                    }
                }
            });
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-user-info {
    padding-bottom: 30px;
    .acct-box {
        padding: 20px 10px;
        .el-form-item {
            margin-bottom: 18px;
            &.is-required .el-form-item__label:before {
                content: "";
            }
            &.required .el-form-item__label:before {
                content: "*";
                color: $color-c;
                margin-right: 2px;
            }
        }
        .btn-group {
            margin-top: 20px;
            text-align: center;
            .el-button + .el-button {
                margin-left: 30px;
            }
        }
        .el-select {
            width: 70%;
            .el-input {
                width: 100%;
            }
        }
        .el-input,
        .el-textarea {
            width: 70%;
            .el-input__inner {
                height: 38px;
                line-height: 36px;
            }
        }
        .vailddate-box {
            .el-select {
                width: 40%;
                .el-input {
                    width: 100%;
                }
            }
            .el-input,
            .el-textarea {
                width: 40%;
            }
            .comp-date-picker {
                width: 100%;
                .el-input {
                    width: 40%;
                }
            }
        }
        .el-form-item__label {
            padding: 0;
            line-height: 38px;
        }
    }
    .check-style {
        margin-right: 10px;
    }
}
</style>
